export default {
    baseStyle: (props) => ({
        aspectRatio: '1/1',
        objectFit: 'cover',
        objectPosition: props?.objectPosition,
        width: '100%',
        maxWidth: {
            base: '18rem',
            md: '20.625rem',
            xl: '28rem'
        }
    }),
    defaultProps: {
        objectPosition: '50% 50%'
    },
    variants: {
        default: () => ({
            maxWidth: {
                base: '18rem',
                md: '20.625rem',
                xl: '28rem'
            }
        }),
        selectRole: () => ({
            aspectRatio: {base: 'auto', md: '1/1'},
            maxWidth: {
                base: '20rem',
                md: '24rem',
                xl: '32rem'
            }
        })
    }
}
